<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col sm="6" lg="3">
				<b-card no-body class="bg-primary">
					<b-card-body class="pb-0">
						<b-dropdown class="float-right" variant="transparent p-0" right>
							<template slot="button-content">
								<i class="icon-settings"></i>
							</template>
							<b-dropdown-item>Action</b-dropdown-item>
							<b-dropdown-item>Another action</b-dropdown-item>
							<b-dropdown-item>Something else here...</b-dropdown-item>
							<b-dropdown-item disabled>Disabled action</b-dropdown-item>
						</b-dropdown>
						<h4 class="mb-0">9.823</h4>
						<p>April</p>
					</b-card-body>
					<card-line1-chart-example class="chart-wrapper px-3" style="height:70px;" height="70"/>
				</b-card>
			</b-col>
			<b-col sm="6" lg="3">
				<b-card no-body class="bg-info">
					<b-card-body class="pb-0">
						<b-dropdown class="float-right" variant="transparent p-0" right no-caret>
							<template slot="button-content">
								<i class="icon-location-pin"></i>
							</template>
							<b-dropdown-item>Action</b-dropdown-item>
							<b-dropdown-item>Another action</b-dropdown-item>
							<b-dropdown-item>Something else here...</b-dropdown-item>
							<b-dropdown-item disabled>Disabled action</b-dropdown-item>
						</b-dropdown>
						<h4 class="mb-0">9.823</h4>
						<p>Marec</p>
					</b-card-body>
					<card-line2-chart-example class="chart-wrapper px-3" style="height:70px;" height="70"/>
				</b-card>
			</b-col>
			<b-col sm="6" lg="3">
				<b-card no-body class="bg-warning">
					<b-card-body class="pb-0">
						<b-dropdown class="float-right" variant="transparent p-0" right>
							<template slot="button-content">
								<i class="icon-settings"></i>
							</template>
							<b-dropdown-item>Action</b-dropdown-item>
							<b-dropdown-item>Another action</b-dropdown-item>
							<b-dropdown-item>Something else here...</b-dropdown-item>
							<b-dropdown-item disabled>Disabled action</b-dropdown-item>
						</b-dropdown>
						<h4 class="mb-0">9.823</h4>
						<p>Februar</p>
					</b-card-body>
					<card-line3-chart-example class="chart-wrapper" style="height:70px;" height="70"/>
				</b-card>
			</b-col>
			<b-col sm="6" lg="3">
				<b-card no-body class="bg-danger">
					<b-card-body class="pb-0">
						<b-dropdown class="float-right" variant="transparent p-0" right>
							<template slot="button-content">
								<i class="icon-settings"></i>
							</template>
							<b-dropdown-item>Action</b-dropdown-item>
							<b-dropdown-item>Another action</b-dropdown-item>
							<b-dropdown-item>Something else here...</b-dropdown-item>
							<b-dropdown-item disabled>Disabled action</b-dropdown-item>
						</b-dropdown>
						<h4 class="mb-0">9.823</h4>
						<p>Januar</p>
					</b-card-body>
					<card-bar-chart-example class="chart-wrapper px-3" style="height:70px;" height="70"/>
				</b-card>
			</b-col>
		</b-row>
		<b-card>
			<b-row>
				<b-col sm="5">
					<h4 id="traffic" class="card-title mb-0">Promet</h4>
					<div class="small text-muted">April 2018</div>
				</b-col>
				<b-col sm="7" class="d-none d-md-block">
					<b-button type="button" variant="primary" class="float-right"><i class="icon-cloud-download"></i></b-button>
					<b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
					<b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
						<b-form-radio class="mx-0" value="Day">Dan</b-form-radio>
						<b-form-radio class="mx-0" value="Month">Mesec</b-form-radio>
						<b-form-radio class="mx-0" value="Year">Leto</b-form-radio>
					</b-form-radio-group>
					</b-button-toolbar>
				</b-col>
			</b-row>
			<main-chart-example class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"></main-chart-example>
			<div slot="footer">
				<ul>
					<li>
						<div class="text-muted">Prodaja</div>
						<strong>29.703 Vozil (40%)</strong>
						<b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="40"></b-progress>
					</li>
					<li class="d-none d-md-table-cell">
						<div class="text-muted">Priliv</div>
						<strong>4.093 Vozil (5%)</strong>
						<b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="5"></b-progress>
					</li>
					<li>
						<div class="text-muted">Novi</div>
						<strong>78.706 Vozil (60%)</strong>
						<b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="60"></b-progress>
					</li>
					<li class="d-none d-md-table-cell">
						<div class="text-muted">Rabljenih</div>
						<strong>22.123 Vozil (80%)</strong>
						<b-progress height={} class="progress-xs mt-2" :precision="1" variant="danger" :value="80"></b-progress>
					</li>
					<li class="d-none d-md-table-cell">
						<div class="text-muted">Uspešnost</div>
						<strong>40.15%</strong>
						<b-progress height={} class="progress-xs mt-2" :precision="1" :value="40"></b-progress>
					</li>
				</ul>
			</div>
		</b-card>
		<b-row>
			<b-col md="12">
				<b-card header="Promet &amp; Prodaja">
					<b-row>
						<b-col sm="12" lg="4">
							<b-row>
								<b-col sm="6">
									<Callout variant="info">
										<small class="text-muted">Nova vozila</small><br>
										<strong class="h4">9,123</strong>
										<div class="chart-wrapper">
											<callout-chart-example :data="[35, 23, 56, 22, 97, 23, 64]" variant="#20a8d8" width="80" height="30" />
										</div>
									</Callout>
								</b-col>
								<b-col sm="6">
									<Callout variant="danger">
										<small class="text-muted">Rabljena vozila</small><br>
										<strong class="h4">22,643</strong>
										<div class="chart-wrapper">
											<callout-chart-example :data="[65, 59, 84, 84, 51, 55, 40]" variant="#f86c6b" width="80" height="30" />
										</div>
									</Callout>
								</b-col>
							</b-row>
							<hr class="mt-0">
							<ul class="horizontal-bars">
								<li>
									<div class="title">
										Ponedeljek
									</div>
									<div class="bars">
										<b-progress height={} class="progress-xs" :value="34" variant="info"></b-progress>
										<b-progress height={} class="progress-xs" :value="78" variant="danger"></b-progress>
									</div>
								</li>
								<li>
									<div class="title">
										Torek
									</div>
									<div class="bars">
										<b-progress height={} class="progress-xs" :value="56" variant="info"></b-progress>
										<b-progress height={} class="progress-xs" :value="94" variant="danger"></b-progress>
									</div>
								</li>
								<li>
									<div class="title">
										Sreda
									</div>
									<div class="bars">
										<b-progress height={} class="progress-xs" :value="12" variant="info"></b-progress>
										<b-progress height={} class="progress-xs" :value="67" variant="danger"></b-progress>
									</div>
								</li>
								<li>
									<div class="title">
										Četrtek
									</div>
									<div class="bars">
										<b-progress height={} class="progress-xs" :value="43" variant="info"></b-progress>
										<b-progress height={} class="progress-xs" :value="91" variant="danger"></b-progress>
									</div>
								</li>
								<li>
									<div class="title">
										Petek
									</div>
									<div class="bars">
										<b-progress height={} class="progress-xs" :value="22" variant="info"></b-progress>
										<b-progress height={} class="progress-xs" :value="73" variant="danger"></b-progress>
									</div>
								</li>
								<li>
									<div class="title">
										Sobota
									</div>
									<div class="bars">
										<b-progress height={} class="progress-xs" :value="53" variant="info"></b-progress>
										<b-progress height={} class="progress-xs" :value="82" variant="danger"></b-progress>
									</div>
								</li>
								<li>
									<div class="title">
										Nedelja
									</div>
									<div class="bars">
										<b-progress height={} class="progress-xs" :value="9" variant="info"></b-progress>
										<b-progress height={} class="progress-xs" :value="69" variant="danger"></b-progress>
									</div>
								</li>
								<li class="legend">
									<b-badge pill variant="info"></b-badge> <small>Nova vozila</small> &nbsp; <b-badge pill variant="danger"></b-badge> <small>Rabljena vozila</small>
								</li>
							</ul>
						</b-col>
						<b-col sm="6" lg="4">
							<b-row>
								<b-col sm="6">
									<Callout variant="warning">
									<small class="text-muted">Lorem</small><br>
									<strong class="h4">78,623</strong>
									<div class="chart-wrapper">
										<callout-chart-example :data="[35, 23, 56, 22, 97, 23, 64]" variant="#f8cb00" width="80" height="30" />
									</div>
									</Callout>
								</b-col>
								<b-col sm="6">
									<Callout variant="success">
									<small class="text-muted">Ipsom</small><br>
									<strong class="h4">49,123</strong>
									<div class="chart-wrapper">
										<callout-chart-example :data="[65, 59, 84, 84, 51, 55, 40]" variant="#4dbd74" width="80px" height="30" />
									</div>
									</Callout>
								</b-col>
							</b-row>
							<hr class="mt-0">
							<ul class="horizontal-bars type-2">
								<li>
									<i class="icon-user"></i>
									<span class="title">Renaul</span>
									<span class="value">43%</span>
									<div class="bars">
									<b-progress height={} class="progress-xs" :value="43" variant="warning"></b-progress>
									</div>
								</li>
								<li>
									<i class="icon-user-female"></i>
									<span class="title">Nissan</span>
									<span class="value">37%</span>
									<div class="bars">
									<b-progress height={} class="progress-xs" :value="37" variant="warning"></b-progress>
									</div>
								</li>
								<li class="divider"></li>
								<li>
									<i class="icon-user"></i>
									<span class="title">VW</span>
									<span class="value">191,235 <span class="text-muted small">(56%)</span></span>
									<div class="bars">
									<b-progress height={} class="progress-xs" :value="56" variant="success"></b-progress>
									</div>
								</li>
								<li>
									<i class="icon-user"></i>
									<span class="title">BMW</span>
									<span class="value">51,223 <span class="text-muted small">(15%)</span></span>
									<div class="bars">
									<b-progress height={} class="progress-xs" :value="15" variant="success"></b-progress>
									</div>
								</li>
								<li>
									<i class="icon-user"></i>
									<span class="title">Toyota</span>
									<span class="value">37,564 <span class="text-muted small">(11%)</span></span>
									<div class="bars">
									<b-progress height={} class="progress-xs" :value="11" variant="success"></b-progress>
									</div>
								</li>
								<li>
									<i class="icon-user"></i>
									<span class="title">Audi</span>
									<span class="value">27,319 <span class="text-muted small">(8%)</span></span>
									<div class="bars">
									<b-progress height={} class="progress-xs" :value="8" variant="success"></b-progress>
									</div>
								</li>
								<li class="divider text-center">
									<b-button variant="link" size="sm" class="text-muted"><i class="icon-options"></i></b-button>
								</li>
							</ul>
						</b-col>
						<b-col sm="6" lg="4">
							<b-row>
								<b-col sm="6">
									<Callout>
										<small class="text-muted">CTR</small><br>
										<strong class="h4">23%</strong>
										<div class="chart-wrapper">
											<callout-chart-example :data="[78, 81, 80, 45, 34, 12, 40]" width="80px" height="30" />
										</div>
									</Callout>
								</b-col>
								<b-col sm="6">
									<Callout variant="primary">
										<small class="text-muted">Rate</small><br>
										<strong class="h4">5%</strong>
										<div class="chart-wrapper">
											<callout-chart-example :data="[35, 23, 56, 22, 97, 23, 64]" variant="#20a8d8" width="80px" height="30" />
										</div>
									</Callout>
								</b-col>
							</b-row>
							<hr class="mt-0">
							<ul class="icons-list">
								<li>
									<i class="icon-screen-desktop bg-primary"></i>
									<div class="desc">
										<div class="title">Renault Clio</div>
										<small>Lorem ipsum dolor sit amet</small>
									</div>
									<div class="value">
										<div class="small text-muted">Prodanih ta mesec</div>
										<strong>1.924</strong>
									</div>
									<div class="actions">
										<b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
									</div>
								</li>
								<li>
									<i class="icon-screen-smartphone bg-info"></i>
									<div class="desc">
										<div class="title">Renault Megan</div>
										<small>Lorem ipsum dolor sit amet</small>
									</div>
									<div class="value">
										<div class="small text-muted">Prodanih ta mesec</div>
										<strong>1.224</strong>
									</div>
									<div class="actions">
										<b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
									</div>
								</li>
								<li>
									<i class="icon-screen-smartphone bg-warning"></i>
									<div class="desc">
										<div class="title">Renault Laguna</div>
										<small>Lorem ipsum dolor sit amet</small>
									</div>
									<div class="value">
										<div class="small text-muted">Prodanih ta mesec</div>
										<strong>1.163</strong>
									</div>
									<div class="actions">
										<b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
									</div>
								</li>
								<li>
									<i class="icon-user bg-danger"></i>
									<div class="desc">
										<div class="title">Renault Koleos</div>
										<small>Lorem ipsum dolor sit amet</small>
									</div>
									<div class="value">
										<div class="small text-muted">Prodanih ta mesec</div>
										<strong>928</strong>
									</div>
									<div class="actions">
										<b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
									</div>
								</li>
								<li>
									<i class="icon-social-spotify bg-success"></i>
									<div class="desc">
										<div class="title">Renault Captur</div>
										<small>Lorem ipsum dolor sit amet</small>
									</div>
									<div class="value">
										<div class="small text-muted">Prodanih ta mesec</div>
										<strong>893</strong>
									</div>
									<div class="actions">
										<b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
									</div>
								</li>
								<li>
									<i class="icon-cloud-download bg-danger"></i>
									<div class="desc">
										<div class="title">Nissan Juke</div>
										<small>Lorem ipsum dolor sit amet</small>
									</div>
									<div class="value">
										<div class="small text-muted">Prodanih ta mesec</div>
										<strong>121.924</strong>
									</div>
									<div class="actions">
										<b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
									</div>
								</li>
								<li>
									<i class="icon-camera bg-warning"></i>
									<div class="desc">
										<div class="title">Nissan Qashqai</div>
										<small>Lorem ipsum dolor sit amet</small>
									</div>
									<div class="value">
										<div class="small text-muted">Prodanih ta mesec</div>
										<strong>12.125</strong>
									</div>
									<div class="actions">
										<b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
									</div>
								</li>
								<li class="divider text-center">
									<b-button size="sm" variant="link" class="text-muted"><i class="icon-options"></i></b-button>
								</li>
							</ul>
						</b-col>
					</b-row>
					<b-table class="mb-0 table-outline" responsive="sm" hover :items="tableItems" :fields="tableFields" head-variant="light">
						<div slot="avatar" class="avatar" slot-scope="item">
							<img :src="item.value.url" class="img-avatar" alt="">
							<span class="avatar-status" v-bind:class="{ 'bg-success': item.value.status == 'success',	'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"></span>
						</div>
						<div slot="user" slot-scope="item">
							<div>{{item.value.name}}</div>
							<div class="small text-muted">
								<span>
									<template v-if="item.value.new">Novo</template>
									<template v-else>Ponovitev</template>
								</span> | Dodan: {{item.value.registered}}
							</div>
						</div>
						<i slot="country" class="h4 mb-0" :class="flag(item.value.flag)" slot-scope="item" :title="item.value.flag" :id="item.value.flag"></i>
						<i class="flag-icon flag-icon-pw h1" title="pw" id="pw"></i>
						<div slot="usage" slot-scope="item">
							<div class="clearfix">
								<div class="float-left">
									<strong>{{item.value.value}}%</strong>
								</div>
								<div class="float-right">
									<small class="text-muted">{{item.value.period}}</small>
								</div>
							</div>
							<b-progress height={} class="progress-xs" v-model="item.value.value" :variant="variant(item.value.value)"></b-progress>
						</div>
						<i slot="payment" slot-scope="item" :class="item.value.icon" style="font-size:24px"></i>
						<div slot="activity" slot-scope="item">
							<div class="small text-muted">Zadnja prijava</div>
							<strong>{{item.value}}</strong>
						</div>
					</b-table>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import { Callout } from '../components/'

export default {
	name: 'dashboard',
	components: {
		Callout,
		CardLine1ChartExample,
		CardLine2ChartExample,
		CardLine3ChartExample,
		CardBarChartExample,
		MainChartExample,
		SocialBoxChartExample,
		CalloutChartExample
	},
	filters: {
	},
	data: function () {
		return {
			selected: 'Month',
			tableItems: [
				{
					avatar: { url: 'static/img/avatars/1.jpg', status: 'success' },
					user: { name: 'Jana Novak', new: true, registered: 'Jan 1, 2015' },
					country: { name: 'USA', flag: 'us' },
					usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
					payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
					activity: 'pred 10 sek.'
				},
				{
					avatar: { url: 'static/img/avatars/2.jpg', status: 'danger' },
					user: { name: 'Miran Košir', new: false, registered: 'Jan 1, 2015' },
					country: { name: 'Brazil', flag: 'br' },
					usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
					payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
					activity: 'pred 5 min.'
				},
				{
					avatar: { url: 'static/img/avatars/3.jpg', status: 'warning' },
					user: { name: 'Janez Potočnik', new: true, registered: 'Jan 1, 2015' },
					country: { name: 'India', flag: 'in' },
					usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
					payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
					activity: 'pred 1 uro'
				},
				{
					avatar: { url: 'static/img/avatars/4.jpg', status: '' },
					user: { name: 'Jan Hudomuk', new: true, registered: 'Jan 1, 2015' },
					country: { name: 'France', flag: 'fr' },
					usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
					payment: { name: 'PayPal', icon: 'fa fa-paypal' },
					activity: 'pred 2 dnevoma'
				},
				{
					avatar: { url: 'static/img/avatars/5.jpg', status: 'success' },
					user: { name: 'Nina Glazer', new: true, registered: 'Jan 1, 2015' },
					country: { name: 'Spain', flag: 'es' },
					usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
					payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
					activity: 'Prejšnji teden'
				},
				{
					avatar: { url: 'static/img/avatars/6.jpg', status: 'danger' },
					user: { name: 'Vanja Moškon', new: true, registered: 'Jan 1, 2015' },
					country: { name: 'Poland', flag: 'pl' },
					usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
					payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
					activity: 'Pred 3 dnevi'
				}
			],
			tableFields: {
				avatar: {
					label: '<i class="icon-people"></i>',
					class: 'text-center'
				},
				user: {
					label: 'Prodajalec'
				},
				country: {
					label: 'Enota',
					class: 'text-center'
				},
				usage: {
					label: 'Uspešnost'
				},
				payment: {
					label: 'Način plačila',
					class: 'text-center'
				},
				activity: {
					label: 'Aktiven'
				}
			}
		}
	},
	methods: {
		variant (value) {
			let $variant
			if (value <= 25) {
				$variant = 'info'
			} else if (value > 25 && value <= 50) {
				$variant = 'success'
			} else if (value > 50 && value <= 75) {
				$variant = 'warning'
			} else if (value > 75 && value <= 100) {
				$variant = 'danger'
			}
			return $variant
		},
		flag (value) {
			return 'flag-icon flag-icon-' + value
		}
	},
	computed: {
	}
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/Dashboard.vue